import Glide, { Controls, Breakpoints, Images, Swipe, Autoplay  } from '@glidejs/glide/dist/glide.modular.esm';
import $ from 'jquery';
import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

import '../scss/master.scss';
import '@glidejs/glide/dist/css/glide.core.min.css';
import 'lightgallery/css/lightgallery-bundle.css';

window.$ = $;

addEventListener('DOMContentLoaded', (event) => 
{
  watchScroll();

  $(document).on('scroll', function(){
    watchScroll();
  });

  function watchScroll()
  {
    let top = $(document).scrollTop();
    let collapse_logo_above = 100;
    let doc_has_logocollapse = $('body').hasClass('collapse-logo');

    if( top >= collapse_logo_above )
    {
      if( !doc_has_logocollapse )
      {
        $('body').addClass('collapse-logo');
      }
    } else {
      if( doc_has_logocollapse )
      {
        $('body').removeClass('collapse-logo');
      }
    }
  }

  var parkolohandler = $('button[data-parkolo]');
  parkolohandler.each((i,e) => 
  {
    $(e).on('click', function(){
      let hash = $(this).data('hash');
      let darab = $('#darab'+hash).val();
      let recmsg = $('#rec'+hash);
      let aid = $(this).data('parkolo');
      console.log(aid + ' '+ darab);
      let parkele = $('#parkolodarab');
      let parkdb = (parkele.text() != '') ? parseInt(parkele.text()) : 0;

      let newdb = parkdb + parseInt(darab);

      $.post('/wp-admin/admin-ajax.php?action=parkolo_push', {
        car_post_id: aid,
        darab: darab
      },function( res ){
        if( res.error == 0 )
        {
          if( newdb > 0 && !parkele.hasClass('showed') )
          {
            parkele.addClass('showed');
          }
    
          parkele.text( newdb );
    
          recmsg.html('<span style="color:#159937;">'+newdb+' db gépjármű a parkolójában!<br><a style="color:#0b764f; text-decoration: underline;" href="/parkolo/">Parkolóm megtekintése >>></a></span>');
        } 
      }, "json");
    });
  });

  if( $('#auto-gallery').length > 0  )
  {
    lightGallery( 
      document.getElementById('auto-gallery'), 
    {
      plugins: [lgZoom, lgThumbnail],
      speed: 500,
      download: false
    });
  }
  
  if( $('.glide.glide-slider').length > 0 )
  {
    let slider = new Glide('.glide', {
      type: 'slider',
      autoplay: false,
    }).mount( { Swipe, Controls, Breakpoints, Images, Autoplay } );
  } 

  if( $('.velemenyek').length > 0 )
  {
    let velemenyek = new Glide('.velemenyek', {
      type: 'carousel',
      autoplay: 5000,
      perView: 3,
      gap: 35,
      breakpoints: {
        1024: {
          perView: 2
        },
        765: {
          perView: 1
        }
      }  
    }).mount( { Swipe, Controls, Breakpoints, Images, Autoplay } );
  } 

  if( $('.autok').length > 0 )
  {
    let autok = new Glide('.autok', {
      type: 'carousel',
      autoplay: 5000,
      perView: 4,
      gap: 35,
      breakpoints: {
        1280: {
          perView: 3
        },
        860: {
          perView: 2
        },
        765: {
          perView: 1
        }
      }      
    }).mount( { Swipe, Controls, Breakpoints, Images, Autoplay } );
  } 

  var menuopened = false;
  $('.menubar > .menubutton').on('click', function()
  {
    var opened = $('header .menu').hasClass('opened');

    if( !opened )
    {
      $('header .menu').addClass('opened');
      $('body').addClass('menuopened');
      menuopened = true;
    } else {
      $('header .menu').removeClass('opened');
      $('body').removeClass('menuopened');
      menuopened = false;
    }
  });

  var lazyloadImages;  
  if ("IntersectionObserver" in window) {
    lazyloadImages = document.querySelectorAll(".lazy");
    var imageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          if( entry.target.localName == 'div' )
          {
            var div = entry.target;
            div.classList.remove("lazy")
            div.classList.add("lazyloaded");
            div.style.backgroundImage="url("+div.dataset.src+")";
            imageObserver.unobserve(div);
          } else {
            var image = entry.target;
            image.src = image.dataset.src;
            image.classList.remove("lazy");
            image.classList.add("lazyloaded");
            imageObserver.unobserve(image);
          }
        }
      });
    });

    lazyloadImages.forEach(function(image) {
      imageObserver.observe(image);
    });
  } else {  
    var lazyloadThrottleTimeout;
    lazyloadImages = document.querySelectorAll(".lazy");
    
    function lazyload () {
      if(lazyloadThrottleTimeout) {
        clearTimeout(lazyloadThrottleTimeout);
      }    

      lazyloadThrottleTimeout = setTimeout(function() {
        var scrollTop = window.pageYOffset;
        lazyloadImages.forEach(function(img) {
            if(img.offsetTop < (window.innerHeight + scrollTop)) {
              img.src = img.dataset.src;
              img.classList.remove('lazy');
            }
        });
        if(lazyloadImages.length == 0) { 
          document.removeEventListener("scroll", lazyload);
          window.removeEventListener("resize", lazyload);
          window.removeEventListener("orientationChange", lazyload);
        }
      }, 20);
    }

    document.addEventListener("scroll", lazyload);
    window.addEventListener("resize", lazyload);
    window.addEventListener("orientationChange", lazyload);
  }
});